module.exports = __webpack_public_path__ + "files/4a17cbe2c3e1c3c07eb98aede2815882.png";